import {
  IconBrandInstagram,
  IconBrandMeta,
  IconBrandTelegram,
  IconChartBar,
  IconClipboardList,
  IconPlugConnected,
  IconRobot,
  IconShield,
} from '@tabler/icons-react';

type IconRenderer = (size: number) => React.ReactNode;

export const PERMISSION_GROUP_ICONS: Record<string, IconRenderer> = {
  Integrations: (size) => <IconPlugConnected size={size} />,
  Meta: (size) => <IconBrandMeta size={size} />,
  Bot: (size) => <IconRobot size={size} />,
  Analytics: (size) => <IconChartBar size={size} />,
  Checks: (size) => <IconClipboardList size={size} />,
  Access: (size) => <IconShield size={size} />,
};

export const PAGE_ACCESS_SECTION_ICONS: Record<string, IconRenderer> = {
  Prophet: (size) => <IconRobot size={size} />,
  Integrations: (size) => <IconPlugConnected size={size} />,
};

export const PLATFORM_ICONS: Record<string, IconRenderer> = {
  instagram: (size) => <IconBrandInstagram size={size} />,
  telegram: (size) => <IconBrandTelegram size={size} />,
};
